
import { cn } from "@/lib/utils";
import { motion, HTMLMotionProps } from "framer-motion";

function Skeleton({
  className,
  ...props
}: HTMLMotionProps<"div">) {
  return (
    <motion.div
      initial={{ opacity: 0.5 }}
      animate={{ 
        opacity: [0.5, 0.8, 0.5],
        transition: {
          repeat: Infinity,
          duration: 1.5,
          ease: "easeInOut"
        }
      }}
      className={cn(
        "bg-gradient-to-r from-chrona-gray-800/60 via-chrona-gray-700/60 to-chrona-gray-800/60 rounded-md",
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
